import { render, staticRenderFns } from "./HorizontalRadio.vue?vue&type=template&id=402860ac&scoped=true"
import script from "./HorizontalRadio.vue?vue&type=script&lang=js"
export * from "./HorizontalRadio.vue?vue&type=script&lang=js"
import style0 from "./HorizontalRadio.vue?vue&type=style&index=0&id=402860ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402860ac",
  null
  
)

export default component.exports